import { useEffect, useCallback } from "react";
import { $generateHtmlFromNodes } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { BLUR_COMMAND } from "lexical";

const COMMAND_PRIORITY_LOW = 1;

type OnBlurPluginProps = {
	onBlur?: Function;
};

const OnBlurPlugin = ({ onBlur }: OnBlurPluginProps) => {
	const [editor] = useLexicalComposerContext();

	const onBlurHandler = useCallback(
		(value: string) => {
			if (value) onBlur?.(value);
		},
		[onBlur],
	);

	useEffect(
		() =>
			editor?.registerCommand(
				BLUR_COMMAND,
				() => {
					const htmlState = $generateHtmlFromNodes(editor);
					onBlurHandler(htmlState);
					return false;
				},
				COMMAND_PRIORITY_LOW,
			),
		[editor, onBlurHandler],
	);

	return null;
};

export default OnBlurPlugin;
